import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { XpoLtlAuthGuard } from '@xpo-ltl/ngx-auth';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';

import { AppRoutes } from '@shared/enums';
import { RoleCheckGuard } from '@shared/guards/role-check/role-check.guard';
import { SequentialGuard } from '@shared/guards/sequential/sequiential.guard';

// Skip SSO and Firebase sign-in when running in Cypress test environment
const authGuards = !!window['Cypress'] ? [] : [XpoAuthenticationGuard, XpoLtlAuthGuard];

const routerDefinitions: Routes = [
  {
    path: 'pro/:proNumber',
    loadChildren: () =>
      import('./reweigh-log-headers/reweigh-log-headers-home/reweigh-log-headers.module').then(
        (m) => m.ReweighLogHeadersModule
      ),
    canActivate: [SequentialGuard],
    data: {
      sequentialGuards: [...authGuards, RoleCheckGuard],
    },
  },
  {
    path: AppRoutes.REWEIGH_LOG_HEADERS,
    loadChildren: () =>
      import('./reweigh-log-headers/reweigh-log-headers-home/reweigh-log-headers.module').then(
        (m) => m.ReweighLogHeadersModule
      ),
    canActivate: [SequentialGuard],
    data: {
      sequentialGuards: [...authGuards, RoleCheckGuard],
    },
  },
  {
    path: `${AppRoutes.REWEIGH_CALIBRATION_HEADERS}`,
    loadChildren: () =>
      import('./reweigh-calibration-headers/components/reweigh-calibration.module').then(
        (m) => m.ReweighCalibrationModule
      ),
    canActivate: [SequentialGuard],
    data: {
      sequentialGuards: [...authGuards, RoleCheckGuard],
    },
  },

  // ADD ANY NEW ROUTE / PAGE HERE
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: `${AppRoutes.REWEIGH_LOG_HEADERS}`,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routerDefinitions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
